<div *ngIf="pageForm">
  <form class="p8-bdc_page-form__max-width" [formGroup]="pageForm" fxLayout="column">
<!--    <mat-slide-toggle *ngIf="page && page.numchild === 0" [checked]="page.is_favourite" [labelPosition]="'before'"-->
    <mat-slide-toggle *ngIf="page && page.depth === 4" [checked]="page.is_favourite" [labelPosition]="'before'"
                      (change)="switchToFavourite(page)"
                      matTooltip="{{page.is_favourite?'La page apparaîtra dans l\'accueil':'La page n\'apparaîtra pas dans l\'accueil'}}">
      Rendre la page visible dans la page d'accueil
    </mat-slide-toggle>
    <mat-form-field style="padding-bottom: 10px;">
      <label for="title"></label><input matInput
                                        id="title"
                                        placeholder="Titre"
                                        formControlName="title"
                                        required>
      <mat-hint align="start" *ngIf="page && page.slug">lien direct à la page : <strong>{{getSlug()}}</strong> </mat-hint>
      <mat-error *ngIf="pageForm.controls.title.errors?.required">
        Le titre est obligatoire.
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <label for="parent"></label><input matInput
                                         [matAutocomplete]="options"
                                         id="parent"
                                         placeholder="Page / rubrique parente"
                                         formControlName="parent"
                                         required>
      <mat-hint align="end" *ngIf="pageParent && pageParent.numchild"><code>nombre de pages dans cette rubrique : {{pageParent.numchild}}</code></mat-hint>
      <mat-error *ngIf="pageForm.controls.parent.errors?.required">
        La page parente est obligatoire.
      </mat-error>
    </mat-form-field>
    <mat-autocomplete #options="matAutocomplete" [displayWith]="displayPageName">
      <mat-option *ngFor="let page of pages$ | async" [value]="page" (onSelectionChange)="onSelect($event)">
        {{ page.title }}
      </mat-option>
    </mat-autocomplete>

<!--    <mat-form-field *ngIf="pageParent && pageParent.numchild">-->
<!--      <mat-select formControlName="order"-->
<!--                  placeholder="Ordre de la page dans cette rubrique / page parente"-->
<!--                  fxFlexAlign="center">-->
<!--        <mat-option *ngFor="let value of orders" [value]="value">{{value}}</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <mat-slide-toggle *ngIf="page" [checked]="page.is_published" [labelPosition]="'before'"
                    (change)="switchOnOffLine(page)"
                    matTooltip="{{page.is_published?'une page publiée appraîtra sur le site':'non publiée, n\'apparaîtra pas sur le site'}}">
      Publier
    </mat-slide-toggle>

  </form>
  <div class="p8-bdc_page-new__icons__container" fxLayout="row" fxLayoutAlign="start center">
      <button mat-raised-button (click)="openIconsDialog()"  [disabled]="isOpenIcons">
        CHOISIR ICONE
      </button>
      <span *ngIf="! icon" class="p8-secondary">Aucune icône choisie</span>
      <mat-icon>{{ icon }}</mat-icon>
      <button mat-icon-button *ngIf="icon" (click)="deleteIcon($event)">
        <mat-icon class="p8-secondary" matTooltip="Enlever l'icône de la page">close</mat-icon>
      </button>
  </div>

  <mat-divider></mat-divider>

  <div class="p8-bdc_page-form__max-width">
    <p class="mat-subheading-2">Contenu</p>
    <div class="p8-bdc_add-block__container" fxLayout="column" fxLayoutAlign="start center">
      <div *ngIf="body.length == 0" class="p8-secondary p8-bdc_add-block__help-text">
        Pour l'instant cette page est vide. Veuillez ajouter du contenu.
      </div>
      <p8-bdc-add-block-button (newBlock)="addBlock($event)"></p8-bdc-add-block-button>
    </div>

    <p8-bdc-page-blocks *ngIf="body.length > 0" [body]="body" (newBlock)="addBlock($event)" (blockImageChange)="onImageBlock($event)"></p8-bdc-page-blocks>
  </div>

  <mat-divider></mat-divider>

  <p class="mat-subheading-2">Documents attachés</p>

  <input hidden
         type="file"
         #fileInput
         name="fileInput"
         multiple>

  <div class="p8-secondary p8-bdc_page-form__help-text" *ngIf="documents.length === 0">
    Aucun document a été ajouté
  </div>

  <div class="p8-secondary p8-bdc_page-form__help-text" *ngIf="documents.length > 0">
      <mat-chip-list class="mat-chip-list-stacked">
        <mat-chip *ngFor="let doc of documents;">
          <button mat-icon-button (click)="removeDocConfirm(doc)" matTooltip="Enlever le document de la page">
            <mat-icon class="mat-16">close</mat-icon>
          </button>
          <span class="fill-space"></span>
          {{doc.title}} {{doc.filename}}
          <span class="fill-space"></span>
          <button mat-icon-button (click)="download(doc)" matTooltip="Télécharger le fichier">
            <mat-icon class="mat-16">file_download</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-list>
  </div>

  <button mat-raised-button (click)="openDocuments()">
    AJOUTER DOCUMENT
  </button>

  <div *ngIf="page?.created_by_obj">
    <mat-divider></mat-divider>
    <span>Créateur : <a href="mailto:{{page?.created_by_obj?.email}}">{{page?.created_by_obj?.first_name}} {{page?.created_by_obj?.last_name}}</a></span>
  </div>

  <p8-bdc-settings-gestionnaires *ngIf="hasRightsManageGest && page && page?.pageuser_obj" [pageUsers]="page?.pageuser_obj" [page]="page"></p8-bdc-settings-gestionnaires>

</div>
